<template>
    <div class="conversation-wrapper frquency-new-conversation" v-if="!isLoading">
        <section class="w-100">
            <b>You can send a message to more than one user.</b>
            <div class="d-flex w-100 align-items-baseline chat-users pt-2">
                <TagsInput
                    class="w-100"
                    :getData="getUsersList"
                    :tags="users"
                    v-on:updateTags="updateTags"
                    placeholder="Start Typing a Name"
                    :is-focus="true"
                    :is-for-messaging="true"
                    :show-pill="false"
                    classes="w-100 form-group"
                />
            </div>
        </section>
        <section class="conversation-body">
            <!-- DO NOT DELETE THIS SECTION -->
        </section>
        <footer class="conversation-input" :class="{ 'highlight-important': newMessage.isImportant }">
            <MessageInputHandler
                :initial-message="newMessage.message"
                :is-important="newMessage.isImportant"
                v-model:files="files"
                :send="sendMessage"
                :toggle-important="toggleImportant"
            />
        </footer>
    </div>
    <div class="p-5 w-100 d-flex flex-column text-center text-primary" v-if="isLoading">
        <i class="far fa-save fa-7x me-2 animated slow flash infinite"></i>
        <div class="big-text mt-1">
            <b>Sending Message...</b>
        </div>
    </div>
</template>

<script src="./FrequencyWatchHosForm.ts"></script>
<style src="./FrequencyWatchHosForm.scss"></style>
